import {styled, Box} from '@mui/material';

export const SettingsCard = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '24px',
  backgroundColor: '#FFF',
  border: '1px solid #E1E5E4',
  borderRadius: '16px',
}));
